import { Components, Theme } from "@mui/material"

export const MuiTableBody: Required<Components<Theme>>["MuiTableBody"] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      backgroundColor: palette["bg-primary"],
      color: palette["text-primary"],
      ".MuiTableRow-root": {
        borderTop: `1px solid ${palette["border-secondary"]}`,
        "&:hover": {
          backgroundColor: palette["bg-primary_hover"],
        },
      },
    }),
  },
}
